import { render, staticRenderFns } from "./writeoff.vue?vue&type=template&id=b7e21882&scoped=true"
import script from "./writeoff.vue?vue&type=script&lang=js"
export * from "./writeoff.vue?vue&type=script&lang=js"
import style0 from "./writeoff.vue?vue&type=style&index=0&id=b7e21882&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e21882",
  null
  
)

export default component.exports